import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { Box, Fab } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const GoToTopButton = () => {
  const [showGoTop, setShowGoTop] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (window.pageYOffset > 150) {
      setShowGoTop(true);
    }
  }, []);

  const handleVisibleButton = () => {
    if (window.pageYOffset > 150) {
      setShowGoTop(true);
    } else {
      setShowGoTop(false);
    }
  };

  const handleScrollUp = () => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleVisibleButton);
  }, []);

  return (
    <Box>
      {showGoTop ? (
        <Fab
          variant="extended"
          sx={{
            margin: 0,
            top: 'auto',
            left: 'auto',
            bottom: 30,
            right: 30,
            position: 'fixed',
            borderRadius: 0,
          }}
          color="primary"
          aria-label="filter"
          onClick={handleScrollUp}
        >
          <KeyboardDoubleArrowUpIcon />
          {t('GoToTop')}
        </Fab>
      ) : null}
    </Box>
  );
};
